export class InsiderUserDTO {
  name?: string;

  email?: string;

  phone_number?: string;

  gdpr_optin: boolean | null;

  custom?: {
    [key: string]: any;
  };

  /**
   * Initializes a new instance of the InsiderUser class.
   *
   * @param {Partial<InsiderUser>} params - The parameters to assign to this instance.
   */
  constructor(params: Partial<InsiderUserDTO>) {
    this.name = params?.name ?? "";
    this.email = params?.email ?? "";
    this.phone_number = params?.phone_number ?? "";
    this.gdpr_optin = params?.gdpr_optin ?? null;
    this.custom = params?.custom ?? {};
  }
}
